module.exports = __webpack_public_path__ + "static/img/t2.f3c67ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/t2.png
// module id = DkkH
// module chunks = 1